import { object, string } from 'yup';
import { eDepositorType } from '../../../../../../types/order/emdAccess/eDepositorType';

export const emdAccessCodeValidation = object({
  orderId: string().uuid().required(),
  depositorId: string().uuid().required(),
  depositorType: string().oneOf(Object.values(eDepositorType)).required(),
});
